import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { IMenuItemContainer } from "./MenuItem.interface";
import { ssm, MUITheme } from "../../../AppTheme.styled";

const getSpacing = (spacing: IMenuItemContainer["spacing"] = 1) =>
  typeof spacing === "number"
    ? `${spacing * 8}px 0`
    : `${spacing[0] * 8}px 0 ${spacing[1] * 8}px 0`;

const StyledMenuItem = styled(NavLink)<IMenuItemContainer>`
  width: 100%;
  font-size: 16px;
  line-height: 23px;
  padding: 0 25px;
  margin: ${({ spacing }) => getSpacing(spacing)};
  height: 40px;
  text-decoration: none;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.neutral2};

  svg {
    margin-right: 8px;
    width: 20px;
    color: ${({ theme }) => theme.palette.neutral3};
  }

  &:hover {
    color: ${({ theme }) => theme.palette.primary};

    svg {
      color: ${({ theme }) => theme.palette.primary};
    }
  }

  &.active {
    color: ${({ theme }) => theme.palette.primary};
    background-color: ${({ theme }) => theme.palette.background3};

    svg {
      color: ${({ theme }) => theme.palette.primary};
    }
  }

  ${MUITheme.breakpoints.down("sm")} {
    padding: 0 16px;
  }

  ${ssm} {
    border-radius: ${({ rounded = true }) => (rounded ? "10px" : "0")};
  }
`;

export default StyledMenuItem;
